<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'subject',
    navActiveLink: 'subjects',
  },
})
 
import { useApi } from "@/composables/useApi"
import { useScheduleStore } from "@/utils/stores/schedule"
import MultiAnswer from "@/views/assignment/crf-answer/MultiAnswer.vue"
import SubjectList from "@/views/assignment/view/subjectList.vue"
 
const route = useRoute()
const router = useRouter()
 
const groupId = ref("0")
const cycleId = ref("0")
const visitId = ref("0")
const scheduleId = ref(route.params.schedule || "0")
const nextScheduleId = ref("0")


const crfGroup = ref()
const cycleVisit = ref()
const schedule = ref()
const crfAnswer = ref()
const open = ref(0)

 
const selectedSubject = ref({})
 
// 👉 SubjectList에서 선택될 경우
const selectSubject = value => {
  selectedSubject.value = value
}
 
console.log(route.params)
 
 
// 👉 URL에서 넘어온 경우, subject fetch
const {
  data: subjectData,
  execute: fetchSubject,
  isLoading,
  error,
} = await useApi(createUrl(`/subjects/${route.params.subject}`))
 
watch(subjectData, () => {
  if (subjectData.value) {
    console.log(" watch selected Subject")
    selectedSubject.value = subjectData.value
  }
})
 
// ✅ fallback으로도 세팅
onMounted(() => {
  if (subjectData.value) {
    console.log("selected Subject", subjectData.value)
    selectedSubject.value = subjectData.value
  }
}) 


const fetchDatas = async () => {
  const { data, error } = await useApi(createUrl('/standard/build-datas', {
    query: {
      projectId: getProjectId(),
      subjectId: selectedSubject.value?.id,
    },
  }))

  if (error.value) {
    console.error(error.value)
  } else {
    if (data.value) {

      console.log(data.value)
      crfGroup.value = data.value.crfGroup
      cycleVisit.value = data.value.cycleVisit
      schedule.value = data.value.schedule
      crfAnswer.value = data.value.standardAnswer
 
 
      buildAnswerList() 

    }
  }
}

fetchDatas()

const answerList = ref([])

const buildAnswerList = () => {
  const list = []

  console.log(cycleVisit)
  cycleVisit?.value.forEach(cycle => {
    cycle.visits.forEach(visit => {
      crfGroup.value.forEach(group => {
        const matchedSchedule = schedule.value.find(s =>
          s.cId == cycle.id &&
          s.vId == visit.id &&
          s.gId == group.id,
        )

        if (matchedSchedule) {
          const matchedAnswer = crfAnswer.value?.find(a => a.schedule_id == matchedSchedule.id)

          list.push({
            groupId: group.id,
            cycleId: cycle.id,
            visitId: visit.id,
            scheduleId: matchedSchedule.id,
            nextScheduleId: 0, // 옵션
            animalName: matchedAnswer?.animalName || group.label,
            status: matchedAnswer?.status || 0,
          })
        }
      })
    })
  })

  console.log(list)
  answerList.value = list
}



 
// 👉 Answer 컴포넌트에서 선택된 경우 정보 갱신
const onSelectedAnswer = (s, sId, nsId, status) => {
  groupId.value = s.gId + ""
  cycleId.value = s.cId + ""
  visitId.value = s.vId + ""
  scheduleId.value = sId + ""
  nextScheduleId.value = nsId + ""
 
  useScheduleStore().setScheduleStatus(route.params.subject, status)
}
 


const refSelectAnswer = ref()
 
const saveAnswer = () => {
  refSelectAnswer.value.fetchDatas()
}
 
const onNext = nsId => {
  scheduleId.value = nextScheduleId.value
  refSelectAnswer.value.fetchDatas()
}
</script>
 
<template>
  <VRow>
    <VCol
      cols="12"
      md="3"
      style="max-inline-size:400px"
    >
      <SubjectList @select-subject="selectSubject" />
    </VCol>
    <VCol
      cols="12"
      md="9"
    > 
      <template v-if="selectedSubject && answerList.length">
        <MultiAnswer
          :subject="selectedSubject"
          :answer-list="answerList"
        />
      </template>
      <template v-else>
        <div class="pa-4 text-grey">
          좌측에서 피험자를 선택해주세요.
        </div>
      </template>
    <!--
      <Answer
      ref="refSelectAnswer"
      :group-id="1"
      :cycle-id="1"
      :visit-id="1"
      :schedule-id="1"
      :next-schedule-id="0"
      :subject="selectedSubject"
      @save-answer="saveAnswer"
      @on-next="onNext"
      />  
      <template v-if="selectedSubject && answerList?.length">
      <VCard
      v-for="(answer) in answerList"
      :key="answer.id"
      class="mb-4"
      >
      <VCardText>
      <Answer
      :group-id="String(answer.groupId)"
      :cycle-id="String(answer.cycleId)"
      :visit-id="String(answer.visitId)"
      :schedule-id="answer.scheduleId"
      :next-schedule-id="String(answer.nextScheduleId)"
      :subject="selectedSubject"
      @save-answer="saveAnswer"
      @on-next="onNext"
      />
      </VCardText>
      </VCard>
      </template>
 
      <template v-else-if="selectedSubject && !answerList?.length">
      <div class="text-grey pa-4">
      해당 피험자의 답변 데이터가 없습니다.
      </div>
      </template>
 
      <template v-else>
      <div class="text-grey pa-4">
      좌측에서 피험자를 선택해주세요.
      </div>
      </template>
    -->
    </VCol>
  </VRow>
</template>
 